import { Box, Fade, IconButton, Modal, Typography } from "@mui/material";
import React, { useState } from "react";
import CloseIcon from "@mui/icons-material/Close";
import CreateSales from "../../pages/PrimeFigma/CreateSales";

const style = {
  position: "absolute",
  left: "5%",
  right: "5%",
  // transform: 'translate(-50%, -50%)',
  bgcolor: "background.paper",
  boxShadow: 24,
  paddingBottom: 2,
  outline: "none",
  height: "93vh",
};

function AddPNFSales({ open, setOpen, accountDetails }) {
  const [taxable, setTaxable] = useState(true);
  const [nontaxable, setNonTaxable] = useState(false);
  const [pos, setPOS] = useState(false);

  const handleClose = (event, reason) => {
    if (reason !== "backdropClick") {
      setOpen(false);
      localStorage.removeItem("modalOpen")
    }
  };
  return (
    <Modal
      aria-labelledby="transition-modal-title"
      aria-describedby="transition-modal-description"
      open={open}
      onClose={handleClose}
      closeAfterTransition
    >
      <Fade in={open}>
        <Box sx={style}>
          <Box
            sx={{
              backgroundColor: "primary.main",
              padding: "3px 3px",
              display: "flex",
              flexDirection: "row",
            }}
          >
            <Box sx={{ flex: 1 }}>
              <Typography
                sx={{
                  color: "#fff",
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                {taxable && "Add Taxable Invoice & Income"}
                {nontaxable && "Add Non Taxable Invoice & Income"}
                {pos && "Add Sale And Income - POS"}
                <IconButton aria-label="delete" onClick={handleClose}>
                  <CloseIcon sx={{ color: "#fff" }} />
                </IconButton>
              </Typography>
            </Box>
          </Box>

          <Box
            className="custom-scrollbar"
            sx={{ overflow: "scroll", height: "80vh",  padding:"10px"}}
          >
            <CreateSales
              isVoucher={handleClose}
              accountDetails={accountDetails}
            />
          </Box>
        </Box>
      </Fade>
    </Modal>
  );
}

export default AddPNFSales;
